// Implements: F-UIX-018, F-IDN-027
/**
 * `/backoffice/teams`: Equipos (mockup v3 P3). The organization comes from the session's
 * permission answer (`team:create` for its admin, `team_member:add` for a team lead); the cards and
 * "Nuevo equipo" from the organization module's `TeamsContainer`, keyed by organization and person.
 */

import type { ReactElement } from "react";

import { ByOrganization } from "../../modules/organization/containers/ByOrganization";
import { TeamsContainer } from "../../modules/organization/containers/TeamsContainer";
import { allowsAtOrganization } from "../../modules/organization/model/targets";
import { useSession } from "../../shared/api/session";
import { useTranslation } from "../../shared/i18n";
import { PageHeader } from "../../shared/ui/molecules/PageHeader";

export const TEAM_ACTIONS = ["team:create", "team_member:add"] as const;

export function TeamsPage(): ReactElement | null {
  const { t } = useTranslation();
  const { state } = useSession();
  // `RequireSession` renders this page only for a session; nothing to show otherwise.
  if (state.status !== "authenticated") return null;
  const { user, scopes } = state.view;

  return (
    <section>
      <ByOrganization key={user.id} scopes={scopes} actions={TEAM_ACTIONS}>
        {(target) => (
          <>
            <PageHeader
              title={t("organization.teams.title")}
              subtitle={
                allowsAtOrganization(scopes, target.organizationId, "team:create")
                  ? t("organization.teams.intro")
                  : t("organization.teams.leadIntro")
              }
            />
            <TeamsContainer organizationId={target.organizationId} scopes={scopes} />
          </>
        )}
      </ByOrganization>
    </section>
  );
}
